/**
 * 共通設定の呼び出し
 */

const commonScripts = () => {
	const pagetop = document.getElementById("go-top");
	window.addEventListener("scroll", function () {
		//スクロールが100に達したらボタン表示
		if (window.scrollY > 100) {
			pagetop.classList.add("show");
		} else {
			pagetop.classList.remove("show");
		}
	});

	// ページ内スクロールの設定
	document.querySelectorAll(".page-scroll > a").forEach(function (anchor) {
		anchor.addEventListener("click", function (event) {
			event.preventDefault();
			const targetId = this.getAttribute("href");
			const targetElement = document.querySelector(targetId);
			if (targetElement) {
				const position = targetElement.offsetTop;
				window.scrollTo({
					top: position,
					behavior: "smooth",
				});
			}
		});
	});

	const buttons = document.querySelectorAll(".accordion-button");

	if (!buttons.length) return; // ボタンが存在しない場合は何もしない
	buttons.forEach((button) => {
		const icon = button.querySelector(".toggle-icon");
		const targetId = button.getAttribute("data-bs-target");
		const collapseEl = document.querySelector(targetId);
		if (!icon) return; // アイコンが無ければスキップ
		// 初期状態の collapse に応じてアイコンを設定
		const isOpen = collapseEl.classList.contains("show");

		requestAnimationFrame(() => {
			icon.classList.add(isOpen ? "bi-dash" : "bi-plus");
		});
		// イベントリスナー
		collapseEl.addEventListener("show.bs.collapse", () => {
			icon.classList.remove("bi-plus");
			icon.classList.add("bi-dash");
		});

		collapseEl.addEventListener("hide.bs.collapse", () => {
			icon.classList.remove("bi-dash");
			icon.classList.add("bi-plus");
		});
	});

	document.querySelectorAll(".third-button").forEach((button) => {
		const icon = button.querySelector(".animated-icon");

		button.addEventListener("mouseenter", () => {
			if (icon) icon.classList.add("onover");
		});

		button.addEventListener("mouseleave", () => {
			if (icon) icon.classList.remove("onover");
		});
	});
};

export default commonScripts;
